import VoiceSolutionBuilderManager from '../components/VoiceSolutionBuilderManager';

export default function AdminVoiceSolutionsPage() {
  return (
    <div className="space-y-6" data-testid="admin-voice-solutions-page">
      <div>
        <h1 className="text-3xl font-bold" data-testid="admin-voice-solutions-title">Voice Solution Builder</h1>
        <p className="text-muted-foreground" data-testid="admin-voice-solutions-subtitle">
          Create and manage industry-specific voice call solutions and map them to campaigns.
        </p>
      </div>
      <VoiceSolutionBuilderManager />
    </div>
  );
}
